const Buffer = function(capacity) {
    this.capacity = capacity || (8 * 1024);
    const buf = new ArrayBuffer(this.capacity);
    this.buffer = new Uint8Array(buf);
    this.count = 0;
    //console.log('New Buffer capacity ', this.capacity);
};

const pt = Buffer.prototype;

pt.resize = function(capacity) {
    capacity = capacity || (8 * 1024)
    //console.log('Buffer Resize ', this.capacity, "=>", capacity);
    const buf = new ArrayBuffer(capacity);
    const uint8 = new Uint8Array(buf);
    uint8.set(this.buffer.subarray(0, this.count));
    this.buffer = uint8;
    this.capacity = capacity;
};

pt.blockCopy = function(buf, offset, count) {
    //console.log('Buffer Copy ', count, "=>", this.count);

    if (this.capacity - this.count < count) {
        let capacity = this.capacity * 2;
        while(capacity - this.count < count) {
            capacity = capacity * 2;
        }
        this.resize(capacity);
    }

    if (buf instanceof Uint8Array) {
        const src = buf.subarray(offset, offset + count);
        this.buffer.set(src, this.count);
        this.count += count;
    }
    else {
        for (let i = 0; i < count; i++) {
            this.buffer[this.count++] = buf[offset + i];
        }
    }

    //console.log('blockCopy', count, this.count);
};


export default Buffer;
